/**
 * @license GPL-3.0-only
 *
 * @author Mark Mayes / mm-dev
 *
 *
 * @module PD/TIMERS
 *
 * @description
 * ## Basic details for timers used in `setTimeout()` calls
 * - IDs to make `clearTimeout()` simple
 * - Delay values in milliseconds
 */

export const TEXT_FADEIN_SECS = 0.5;
export const TEXT_FADEOUT_SECS = 0.5;
export const TEXT_FADEOUT_SLOW_SECS = 2;

// Level intro
export const LEVEL_INTRO_TEXT_FADEOUT_START_MS = 3000;
export const LEVEL_INTRO_ADDOBSTACLES_MS = 3500;
export const LEVEL_INTROEND_MS = 6000;

// Level outro
export const LEVEL_OUTRO_TEXT_FADEOUT_START_MS = 3000;
export const LEVELOUTRO_OBSTACLE_EXPLOSIONS_TOTALTIME_MS = 3000;
export const LEVEL_OUTROEND_MS = 6000;

